module.exports = __webpack_public_path__ + "img/5bf0f9e.png";